/**
 * @generated SignedSource<<b949e0ef0e2a1234d10ea72f6511b2ee>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Calendar_section",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CalendarResource",
      "kind": "LinkedField",
      "name": "resources",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "color",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "startsAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "endsAt",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "CalendarDayEventsPanel_events"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PageSectionCalendar",
  "abstractKey": null
};

node.hash = "ee0e8b97a3f5e999772df22ceb11394a";

module.exports = node;
